<template>
  <v-row>
    <v-col>
      <router-view name="default" lazy></router-view>
      <router-view name="edit" lazy></router-view>
    </v-col>
  </v-row>
</template>

<script>
// import UsersList from "@/components/console/users/UsersList.vue";
export default {
  data() {
    return {};
  },
  computed: {},
  props: {},
  components: {
    // UsersList
  },
};
</script>

<style scoped></style>
